import React from 'react';
import { Store, Link, Copy } from 'lucide-react';
import { format, parseISO } from 'date-fns';

const getColumns = (isFilterOn, filters, handleFiltersChange) => [
  {
    field: "store_name",
    headerName: "Nome da Loja",
    width: 250,
    renderHeader: () => (
      <div className="flex flex-col items-start justify-center gap-1 h-20 p-2">
        <div className="font-bold whitespace-nowrap">Nome da Loja</div>
        {isFilterOn && (
          <input
            name="store_name"
            value={filters.store_name}
            onChange={handleFiltersChange}
            placeholder="Filtrar"
            className="w-full rounded-md border border-input px-3 py-1 text-xs"
          />
        )}
      </div>
    ),
  },
  {
    field: "spider",
    headerName: "Spider",
    width: 200,
    renderHeader: () => (
      <div className="flex flex-col items-start justify-center gap-1 h-20 p-2">
        <div className="font-bold whitespace-nowrap">Spider</div>
        {isFilterOn && (
          <input
            name="spider"
            value={filters.spider}
            onChange={handleFiltersChange}
            placeholder="Filtrar"
            className="w-full rounded-md border border-input px-3 py-1 text-xs"
          />
        )}
      </div>
    ),
  },
  {
    field: "code",
    headerName: "Código",
    width: 200,
    renderHeader: () => (
      <div className="flex flex-col items-start justify-center gap-1 h-20 p-2">
        <div className="font-bold">Código</div>
        {isFilterOn && (
          <input
            name="code"
            value={filters.code}
            onChange={handleFiltersChange}
            placeholder="Filtrar"
            className="w-full rounded-md border border-input px-3 py-1 text-xs"
          />
        )}
      </div>
    ),
    renderCell: (params) => (
      <div className="flex items-center justify-between w-full">
        <span>{params.value}</span>
        {params.value && (
          <button
            className="p-1 rounded-md hover:bg-accent"
            onClick={(event) => {
              event.stopPropagation();
              navigator.clipboard.writeText(params.value);
            }}
            title="Copiar código"
          >
            <Copy className="h-4 w-4" />
          </button>
        )}
      </div>
    ),
  },
  {
    field: "store_slug",
    headerName: "SLUG",
    width: 250,
    renderHeader: () => (
      <div className="flex flex-col items-start justify-center gap-1 h-20 p-2">
        <div className="font-bold whitespace-nowrap">SLUG</div>
        {isFilterOn && (
          <input
            name="store_slug"
            value={filters.store_slug}
            onChange={handleFiltersChange}
            placeholder="Filtrar"
            className="w-full rounded-md border border-input px-3 py-1 text-xs"
          />
        )}
      </div>
    ),
  },
  {
    field: "is_on_tr",
    headerName: "TR?",
    width: 150,
    renderHeader: () => (
      <div className="flex flex-col items-start justify-center gap-1 h-20 p-2">
        <div className="font-bold whitespace-nowrap">TR</div>
        {isFilterOn && (
          <select
            name="is_on_tr"
            value={filters.is_on_tr}
            onChange={handleFiltersChange}
            className="w-full rounded-md border border-input px-3 py-1 text-xs"
          >
            <option value="">Todos</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        )}
      </div>
    ),
    renderCell: (params) => {
      return params.row.is_on_tr === true ? (
        <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
          Sim
        </span>
      ) : (
        <span className="inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800">
          Não
        </span>
      );
    }
  },
  {
    // Coluna combinada para URLs
    field: "urls",
    headerName: "URLs",
    minWidth: 180,
    renderHeader: () => (
      <div className="flex flex-col items-center justify-center gap-1">
        <div className="font-bold">URLs</div>
      </div>
    ),
    renderCell: (params) => {
      const storeUrl = params.row.store_url;
      const couponUrl = params.row.url;
      
      return (
        <div className="flex items-center gap-3">
          {/* URL da Loja */}
          {storeUrl && (
            <div className="flex flex-col items-center">
              <a 
                href={storeUrl} 
                rel="noopener noreferrer" 
                target="_blank" 
                className="text-blue-600 hover:text-blue-800"
                title={`Loja: ${storeUrl}`}
              >
                <Store className="h-5 w-5" />
              </a>
              <span className="text-xs text-gray-500">Loja</span>
            </div>
          )}
          
          {/* URL do Cupom */}
          {couponUrl && (
            <div className="flex flex-col items-center">
              <a 
                href={couponUrl} 
                rel="noopener noreferrer" 
                target="_blank" 
                className="text-green-600 hover:text-green-800"
                title={`Cupom: ${couponUrl}`}
              >
                <Link className="h-5 w-5" />
              </a>
              <span className="text-xs text-gray-500">Cupom</span>
            </div>
          )}
          
          {/* Link para o site do Thiago Rodrigo */}
          <div className="flex flex-col items-center">
            <a 
              href="https://thiagorodrigo.com.br/dashboard/cupons/" 
              rel="noopener noreferrer" 
              target="_blank" 
              className="text-orange-600 hover:text-orange-800"
              title="Dashboard Cupons - Thiago Rodrigo"
            >
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 4a1 1 0 011-1h12a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1V8zm8 2a1 1 0 100 2h2a1 1 0 100-2h-2z" clipRule="evenodd" />
              </svg>
            </a>
            <span className="text-xs text-gray-500">TR</span>
          </div>
        </div>
      );
    }
  },
  {
    field: "last_time_seen",
    headerName: "Visto por último",
    minWidth: 250,
    renderHeader: () => (
      <div className="flex flex-col items-start gap-1 h-20 p-2">
        <div className="font-bold">Visto por último</div>
        {isFilterOn && (
          <input
            type="date"
            value={filters.last_time_seen || ""}
            onChange={(event) =>
              handleFiltersChange({
                target: { name: "last_time_seen", value: event.target.value },
              })
            }
            className="w-full rounded-md border border-input px-3 py-1 text-xs"
          />
        )}
      </div>
    ),
    renderCell: (params) =>
      params.value
        ? format(parseISO(params.value), "dd/MM/yyyy HH:mm:ss")
        : "",
  },
  {
    field: "first_time_seen",
    headerName: "Visto primeira vez",
    minWidth: 250,
    renderHeader: () => (
      <div className="flex flex-col items-start gap-1 h-20 p-2">
        <div className="font-bold">Visto primeira vez</div>
        {isFilterOn && (
          <input
            type="date"
            value={filters.first_time_seen || ""}
            onChange={(event) =>
              handleFiltersChange({
                target: { name: "first_time_seen", value: event.target.value },
              })
            }
            className="w-full rounded-md border border-input px-3 py-1 text-xs"
          />
        )}
      </div>
    ),
    renderCell: (params) =>
      params.value
        ? format(parseISO(params.value), "dd/MM/yyyy HH:mm:ss")
        : "",
  },
  {
    // Coluna combinada para Título e Descrição
    field: "title_description",
    headerName: "Título e Descrição",
    minWidth: 600,
    renderHeader: () => (
      <div className="flex flex-col items-start gap-1 h-20 p-2">
        <div className="font-bold">Título e Descrição</div>
        {isFilterOn && (
          <div className="flex flex-col gap-1 w-full">
            <input
              name="title"
              value={filters.title || ""}
              onChange={handleFiltersChange}
              placeholder="Filtrar título"
              className="w-full rounded-md border border-input px-2 py-1 text-xs"
            />
          </div>
        )}
      </div>
    ),
    renderCell: (params) => {
      const title = params.row.title;
      const description = params.row.description;
      
      return (
        <div className="flex flex-col gap-2 w-full py-2">
          {/* Título */}
          {title && (
            <div className="flex items-start justify-between w-full">
              <div className="font-bold text-gray-900 flex-1 pr-2">
                {title}
              </div>
              <button
                className="p-1 rounded-md hover:bg-accent flex-shrink-0"
                onClick={(event) => {
                  event.stopPropagation();
                  navigator.clipboard.writeText(title);
                }}
                title="Copiar título"
              >
                <Copy className="h-4 w-4 text-gray-500" />
              </button>
            </div>
          )}
          
          {/* Descrição */}
          {description && (
            <div className="flex items-start justify-between w-full">
              <div className="text-gray-600 text-sm flex-1 pr-2 leading-relaxed">
                {description}
              </div>
              <button
                className="p-1 rounded-md hover:bg-accent flex-shrink-0"
                onClick={(event) => {
                  event.stopPropagation();
                  navigator.clipboard.writeText(description);
                }}
                title="Copiar descrição"
              >
                <Copy className="h-4 w-4 text-gray-500" />
              </button>
            </div>
          )}
        </div>
      );
    }
  },
];

export default getColumns;